// Bootstrap dialog logic in React.

import React, { useEffect, useState, useRef } from 'react';

// Default footer
export const DialogFooter = ({onClose, onAdd, closeText, addText, disabledText, disabled = false, saveDisabled = false, hideSaveButton = false}) => (
  <div className="modal-footer">
    <button disabled={disabled} className="btn btn-default pull-left" onClick={onClose}>{closeText || I18n.t('close')}</button>
    {!hideSaveButton &&
      <button disabled={disabled || saveDisabled} className="btn btn-primary" onClick={onAdd}>{disabled && disabledText ? disabledText : addText || I18n.t('add')}</button>
    }
  </div>
)

// Default header
export const DialogHeader = ({onClose, onAdd, title, showBorder, Tag = 'h2'}) => (
  <div className="modal-header" style={{borderBottom: showBorder ? '1px solid #e5e5e5' : 'none'}}>
    <button className="close" onClick={onClose}>
      <span className="glyphicon glyphicon-remove"></span>
    </button>
    <Tag className="modal-title" id="dialog-label">{title}</Tag>
  </div>
)

const MODAL_SIZES = {
  'sm': 'modal-sm',
  'md': '', // Default
  'lg': 'modal-lg',
  'xl': 'modal-lg modal-xl',
  'fw': 'modal-full-width',
}

const Dialog = ({header = null, footer = null, onClose, children, closeOnOutsideClick = false, closeOnEscape = true, size = 'md', style = {}}) => {
  const wrapperRef = useRef(null);

  const onOutsideClick = (e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)){
      onClose(e);
    }
  }

  const onEscPress = (e) => {
    // Letting other components handle the escape key press first.
    setTimeout(() => {
      if (e.key === 'Escape' && wrapperRef.current) {
        onClose(e);
      }
    }, 0);
  }
  
  useEffect(() => {
    if (closeOnOutsideClick){
      window.addEventListener('click', onOutsideClick, true)
      return () => {window.removeEventListener('click', onOutsideClick, true)}
    }
  }, [])

  useEffect(() => {
    if (closeOnEscape) {
      window.addEventListener('keydown', onEscPress, true);
      return () => window.removeEventListener('keydown', onEscPress, true);
    }
  }, []);

  const dialogSize = MODAL_SIZES[size];

  return <>
    <div className="modal fade in" style={{display: 'block', overflowX: 'hidden', overflowY: 'auto', ...style}}>
      <div className={`modal-dialog ${dialogSize}`} ref={wrapperRef}>
        <div className="modal-content">
          {header}
          <div className="modal-body">
            {children}
          </div>
          {footer}
        </div>
      </div>
    </div>
    <div className="modal-backdrop fade in"></div>
  </>
}

export default Dialog;